import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function(){
  $('.section1').addClass('active')
  let scroH = $(document).scrollTop();
  let t1_top = $('.section1 .left-c').offset().top
  let t2_top = $('.section2 .sec2-title').offset().top
  if (scroH > t2_top - t1_top) {
    $('.section1 .left-t,.section2 .sec2-title .trans').css('transform','translateY(' + (t2_top - t1_top) + 'px)')
  }else{
    $('.section1 .left-t,.section2 .sec2-title .trans').css('transform','translateY(' + scroH + 'px)')
  }

  setTimeout(function(){
    bannerTextSwiper()
  },800)

})

let indexvideo = $('.section1 .ocean video')[0]
$(indexvideo).on('loadedmetadata',function(){
  indexvideo.playbackRate = 1.5
})

function bannerTextSwiper(){
  var swiper1 = new Swiper(".section1 .mySwiper", {
    speed: 1000,
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: { // 自动切换
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    pagination: {// 分页
      el: ".section1 .swiper-pagination",
      clickable: true,
    },
    on:{
			init:function(swiper){
        let slide=this.slides.eq(0);
        slide.addClass('ani-slide');
      },
			transitionStart: function(){
        for(let i=0;i<this.slides.length;i++){
          let slide=this.slides.eq(i);
          slide.removeClass('ani-slide');
        }
      },
			transitionEnd: function(){
				let slide=this.slides.eq(this.activeIndex);
        slide.addClass('ani-slide');
      },
		}
  })
}


$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度


  if (scroH > 50) {
    $('.section1').addClass('line-top')
  }else{
    $('.section1').removeClass('line-top')
  }

  //banner 文字位移
  let t1_top = $('.section1 .left-c').offset().top
  let t2_top = $('.section2 .sec2-title').offset().top
  
  if (scroH > t2_top - t1_top) {
    $('.section1 .left-t,.section2 .sec2-title .trans').css('transform','translateY(' + (t2_top - t1_top) + 'px)')
  }else{
    $('.section1 .left-t,.section2 .sec2-title .trans').css('transform','translateY(' + scroH + 'px)')
  }

  //关于 v子背景显示
  let sec2_top = $('.section2').offset().top - viewH + $('.section2').outerHeight()*0.5
  if( scroH > sec2_top){
    $('.section2 .bg').addClass('active')
  }

  //专业人员 v子背景位移
  let sec4_top = $('.section4 .img-cont').offset().top - viewH
  let transY = $(window).width() > 1024 ? (-(scroH-sec4_top)/2) : (-(scroH-sec4_top)/6)

  if(scroH > sec4_top){
    $('.section4 .img-cont .img1').css('transform','translateY('+ transY +'px)')
  }
});
